import CryptoJS from "crypto-js";
const key = "7xtZ8ieD7jGmduht";  //十六位十六进制数作为密钥
const iv = "Mrm2L0qxAqy8DcZS";   //十六位十六进制数作为密钥偏移量



//解密方法
function decrypt(text) {
  // console.log("对文本进行解密：", text)
  var result = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
  })
  return result.toString(CryptoJS.enc.Utf8)
}

//加密方法
function encrypt(text) {
  // console.log("对文本进行加密：", text)
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
  }).toString()
}

// 全局开关
const enabled = true

export default {
  decrypt,
  encrypt,
  enabled
}
